import { TwoFactorType } from '../enums/two-factor-type.enum';

export class EnableTwoFactorRequest {
  type: TwoFactorType;

  constructor(type: TwoFactorType) {
    this.type = type;
  }
}
